<template>
  <div class="pismo-login-logo">
    <img src="@/assets/img/pismo-orange-2-lines.svg" />
  </div>
</template>

<script setup lang="ts">
</script>

<style></style>
